import { render, staticRenderFns } from "./purchase-apply.vue?vue&type=template&id=4a1ac440&scoped=true"
import script from "./purchase-apply.vue?vue&type=script&lang=js"
export * from "./purchase-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ac440",
  null
  
)

export default component.exports